export class Permission {
	public permissionID: number;
	public permissionName: string;
	public description: string;
}
